import axios from 'axios';
import { MD5 } from '@/utils/crypto';
import BaseApi from '@/api/lib/baseApi';
import Store from '@/store';
import BaseEnv from '@/api/lib/baseEnv';

class Behavior {
  constructor() {
    this.appCode = 'APP44';
    this.env = new BaseEnv().getEnv();
    this.browser = this._browserInfo();
    this.baseApi = new BaseApi();
    this.key = null;
    this.interval = null;
  }
  init() {
    this._initKey();
    this.interval = setInterval(() => {
      this._upServiceData();
    }, 30000);
  }
  _initKey() {
    const url = this._keyAddressConfig();
    axios({ method: 'GET', url, params: { appCode: this.appCode } }).then(res => {
      if (res.status == 200) {
        this.key = res.data.result;
      }
    });
  }
  _keyAddressConfig() {
    return 'https://buriedpoint.weihaibi.cn/appCode/getKey';
  }
  _upServiceData() {
    const date = new moment().format('YYYYMMDDHHmmss');
    const nonce = '123456';
    const body = Store.getters.getBehaviorBody;
    const url = this._upAddressConfig();
    if (body && body.length) {
      const sign = MD5(`appCode=${this.appCode}&date=${date}&nonce=${nonce}${this.key}`);
      axios({ method: 'POST', url, data: { body, appCode: this.appCode, date, nonce, sign } }).then(res => {
        if (res.status == 200) {
          if (res.data.code === 0) {
            Store.commit('Set_Behavior_Body_Del', body.length);
          }
        }
      });
    }
  }
  _upAddressConfig() {
    return 'https://buriedpoint.weihaibi.cn/lo/re';
  }
  _browserInfo() {
    const userAgent = navigator.userAgent;
    let browserName = 'Unknown';
    let fullVersion = 'Unknown';
    if (userAgent.indexOf('Chrome') !== -1 && userAgent.indexOf('Edg') === -1) {
      // 检测 Chrome
      browserName = 'Chrome';
      const match = userAgent.match(/Chrome\/(\d+\.\d+)/);
      if (match) fullVersion = match[1];
    } else if (userAgent.indexOf('Edg') !== -1) {
      // 检测 Edge (基于 Chromium)
      browserName = 'Edge';
      const match = userAgent.match(/Edg\/(\d+\.\d+)/);
      if (match) fullVersion = match[1];
    } else if (userAgent.indexOf('Firefox') !== -1) {
      // 检测 Firefox
      browserName = 'Firefox';
      const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
      if (match) fullVersion = match[1];
    } else if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1) {
      // 检测 Safari
      browserName = 'Safari';
      const match = userAgent.match(/Version\/(\d+\.\d+)/);
      if (match) fullVersion = match[1];
    } else if (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident') !== -1) {
      // 检测 Internet Explorer (旧版)
      browserName = 'Internet Explorer';
      const matchIE = userAgent.match(/MSIE (\d+\.\d+)/);
      const matchTrident = userAgent.match(/rv:(\d+\.\d+)/);
      if (matchIE) fullVersion = matchIE[1];
      else if (matchTrident) fullVersion = matchTrident[1];
    }
    return { name: browserName, version: fullVersion };
  }
  _beforeDataReport(data) {
    const s100 = new moment().format('YYYY-MM-DD');
    const userInfo = Store.getters.getUserInfo;
    const s210 = null;
    const s220 = userInfo ? userInfo.uid : null;
    const s600 = new moment().format('YYYY-MM-DD HH:mm:ss');
    const s620 = this.baseApi.getCookie('ops_c_token');
    const { s500, s531, s502, s504, s507, s508, s509, s510 } = data;
    Store.commit('Set_Behavior_Body_Add', {
      s100, // 分区字段，年月日格式 YYYY-MM-DD
      s210, // 租户id
      s220, // 用户id
      s230: null, // 唯一用户id
      s300: this.appCode, // 应用编码
      s310: 'v6.0', // 应用版本号
      s320: '嗨探C端', // 应用名称
      s330: 'PC', // 设备类型 PC,H5,Android,IOS
      s340: this.env == 'pro' ? 'e5' : 'e3', // 环境 e3,e5
      s350: 's9', // 渠道 其它
      s407: this.browser ? this.browser.name : null,
      s408: this.browser ? this.browser.version : null,
      s500, // page_view,page_click,search,ad
      s501: null, // 当前进入页面ID
      s502, // 当前页面ID
      s504, // 当前页面名称
      s507, // 停留时长
      s508, // 页面层级
      s509, // 上级页面ID 必填
      s510, // 上级页面名称 必填
      s519: 'W1', // 入口类型
      s531, // 按钮名称
      s600,
      s620,
      s641: 'F',
    });
  }
  click(data, to) {
    const s500 = 'page_click';
    const s502 = to.meta.pageId;
    const s504 = to.meta.pageName;
    const s509 = to.meta.parentId;
    const s510 = to.meta.parentName;
    const s508 = to.meta.pageLayer;
    const { s531 } = data;
    s531 && this._beforeDataReport({ s500, s502, s504, s508, s509, s510, s531 });
  }
  page(to) {
    const s500 = 'page_view';
    const s502 = to.meta.pageId;
    const s504 = to.meta.pageName;
    const s509 = to.meta.parentId;
    const s510 = to.meta.parentName;
    const s508 = to.meta.pageLayer;
    s502 && this._beforeDataReport({ s500, s502, s504, s508, s509, s510 });
  }
  destroy() {
    this.interval && clearInterval(this.interval);
    this._upServiceData();
  }
}
export default {
  install(Vue) {
    if (this.installed) return;
    this.installed = true;
    Vue.prototype.bInstance = new Behavior();
    // 将api属性设置为不可写，为了防止某些插件冲突
    Object.defineProperty(Vue.prototype, 'bInstance', {
      configurable: false, // 不可删除
      writable: false, // 不可写
    });
  },
};
